// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
/* Message 全局美化（需在 Element 主题样式之后引入） */
import './assets/css/message.css'
import store from '@/store/index'
import i18n from '@/i18n'

/* 全局提示默认停留 3 秒，便于用户看清内容 */
Vue.use(ElementUI, {
  message: {
    duration: 3000,
  },
});
/* 路由 */
import router from './router'
import { post, get, put, deletes, postfile, toJson, isEmpty, apiHandle } from '@/api/http'
/* axios */
import api from './api/api'
// Vue.prototype.http = axios;
Vue.prototype.$api = api;
console.log("get",get)
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$put = put;
Vue.prototype.$delete = deletes;
Vue.prototype.$postfile = postfile;
Vue.prototype.$toJson = toJson;
Vue.prototype.$store = store;
Vue.prototype.$isEmpty = isEmpty;
Vue.prototype.$apiHandle = apiHandle;
/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'


/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    if(to.meta.title){
      // 使用国际化函数设置页面标题
      document.title = i18n.t(to.meta.title)
    }
    next();
});


new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js